exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".schedule-default-time-slot .active[data-v-212adcb0] {\n  color: #4466f2 !important;\n  background-color: var(--base-color) !important;\n  border-color: var(--default-border-color) !important;\n}", ""]);

// exports
